<template>
  <div class="children">
    <div class="row">
      <div class="col-12 text-center text-sm-start">
        <span class="d-none d-sm-block">
          <page-title v-if="selectedChild" :title="'Kinderen ' + selectedChild.full_name" icon="child"></page-title>
          <page-title v-else :title="'Kinderen'" icon="child"></page-title>
        </span>
        <span class="d-block d-sm-none">
          <page-title :title="'Kinderen'" icon="child"></page-title>
        </span>
      </div>
    </div>
    <div class="row">
        <div class="col-12 col-sm-3" style="">
          <child-list class="d-none d-sm-block" :route="'/children/'"></child-list>
          <child-list-select class="d-block d-sm-none"></child-list-select>
        </div>
        <div v-if="!selectedChild" class="col-12 col-sm-9" style="background: white; height: 100%; padding: 20px;">
          <p class="text-center" style="margin: 50px">
            Selecteer een kind
          </p>
        </div>
        <div v-if="selectedChild" class="col-12 col-sm-9" style="padding-left: 0">
          <ul class="nav nav-tabs">
            <li class="nav-item">
              <router-link class="nav-link" :to="'/children/' + selectedChild.id" exact-active-class="active">
                <span class="d-none d-sm-block">
                  Gegevens
                </span>
                <span class="d-block d-sm-none">
                  I
                </span>
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" :to="'/children/' + selectedChild.id + '/carers'" exact-active-class="active">
                <span class="d-none d-sm-block">
                  Verzorgers
                </span>
                <span class="d-block d-sm-none">
                  V
                </span>
              </router-link>
            </li>
            <li v-if="getApplicationSetting('ipad_child_planning') === '1'" class="nav-item">
              <router-link class="nav-link" :to="'/children/' + selectedChild.id + '/planning'" exact-active-class="active">
                <span class="d-none d-sm-block">
                  Planning
                </span>
                <span class="d-block d-sm-none">
                  P
                </span>
              </router-link>
            </li>
            <li v-if="getApplicationSetting('ipad_child_activities') === '1' || getApplicationSetting('portal_child_activities') === '1'" class="nav-item">
              <router-link class="nav-link" :to="'/children/' + selectedChild.id + '/activities'" exact-active-class="active">
                <span class="d-none d-sm-block">
                  Logboek
                </span>
                <span class="d-block d-sm-none">
                  L
                </span>
              </router-link>
            </li>
            <li v-if="getApplicationSetting('ipad_photos') === '1' || getApplicationSetting('portal_child_photo') === '1'" class="nav-item">
              <router-link class="nav-link" :to="'/children/' + selectedChild.id + '/photos'" exact-active-class="active">
                <span class="d-none d-sm-block">
                  Foto's
                </span>
                <span class="d-block d-sm-none">
                  F
                </span>
              </router-link>
            </li>
              <li v-if="getApplicationSetting('groepsapp_forms') === '1'" class="nav-item">
                  <router-link class="nav-link" :to="'/children/' + selectedChild.id + '/forms'" exact-active-class="active">
                <span class="d-none d-sm-block">
                  Formulieren
                </span>
                      <span class="d-block d-sm-none">
                  I
                </span>
                  </router-link>
              </li>
            <li v-if="getApplicationSetting('child_tracking_system') === '1'" class="nav-item">
              <router-link class="nav-link" :to="'/children/' + selectedChild.id + '/childtrackingsystem'" exact-active-class="active">
                <span class="d-none d-sm-block">
                  KVS Observatie
                </span>
                <span class="d-block d-sm-none">
                  K
                </span>
              </router-link>
            </li>
             <!-- <li class="nav-item">
              <router-link class="nav-link" :to="'/children/' + selectedChild.id + '/dossier'" exact-active-class="active">
                <span class="d-none d-sm-block">
                  Meldcode
                </span>
                <span class="d-block d-sm-none">
                  M
                </span>
              </router-link>
            </li> -->
          </ul>
          <div style="background: white; height: 100%; padding: 20px;">
            <!--
            <div class="row">
              <div class="ml-auto mr-auto col-10 col-sm-2">
                <br>
                <child-thumbnail :child="child"></child-thumbnail>
              </div>
            </div>
            <div class="row">
              <div class="ml-auto mr-auto col-12 col-sm-8 text-center">
                <br>
                <p>
                  <b>
                    {{ child.full_name }}
                  </b>
                  <br>
                  4 jaar
                </p>
              </div>
            </div>-->
            <router-view :id="id"></router-view>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import PageTitle from '@/components/Page-Title'
import ChildList from '@/components/Child-List'
import ChildListSelect from '@/components/Child-List-Select'
export default {
  name: 'children',
  components: {
    PageTitle,
    ChildList,
    ChildListSelect
  },
  props: ['id'],
  created () {
    this.$store.dispatch('getChildren')
    if (this.id) {
      var child = this.getChild(this.id)
      if (child) {
        this.$store.commit('SET_SELECTED_CHILD', child)
        
      } else {
        this.$request.get('/children/?id_child' + this.id)
        .then((response) => {
          if (response.data) {
            this.$store.commit('SET_SELECTED_CHILD', response.data)
          }
        })
      }
    } else if (this.selectedChild) {
      this.$router.push('/children/' + this.selectedChild.id)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .nav-tabs .nav-item.show .nav-link, 
  .nav-tabs .nav-link,
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-link:hover,
  .nav-tabs li, 
  .nav-tabs li:hover {
    border: 0;
    border-color: white;
    border-radius: 0;
    margin-right: 0;
  }
  .nav-tabs>li>a,
  .nav-tabs>li>a.active {
    padding: 19px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #dedee7;
    border: 1px solid #cecece;
  }
  .nav-tabs>li>a:hover, 
  .nav-tabs>li>a.active {
    background-color: white;
  }
  .nav-tabs>li>a, 
  .nav-tabs>li.active>a, 
  .nav-tabs>li.active>a:hover, 
  .nav-tabs>li.active>a:focus, 
  .nav>li>a:hover, 
  .nav>li>a:focus, 
  #children-wrapper .child:hover, 
  .nav-tabs {
    border: 0;
    color: #445161;
    font-weight: 500;
    font-size: 18px;
  }
</style>
